// axiosConfig.js
import axios from 'axios';

export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://hsn.urugowoc.org.rw';

axios.defaults.timeout = 120000;
axios.defaults.withCredentials = true;

// Request interceptor - adds token and language
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Skip adding lang parameter for trainee registration
    if (config.url && config.url.includes('/trainee/register')) {
      // Don't add lang parameter - clean any existing params
      if (config.params && config.params.lang) {
        delete config.params.lang;
      }
      return config;
    }
    
    // Add language parameter for all other requests
    const currentLanguage = localStorage.getItem('language') || 'english';
    if (config.params) {
      config.params.lang = config.params.lang || currentLanguage;
    } else {
      config.params = { lang: currentLanguage };
    }
    
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default axios;